/**
 * Twins — settings page.
 *
 * Route: /prioritization/settings/twins-agent
 *
 * On the agent template since migration 940 (SPEC-custom-agent-template.md
 * T2): the template's common settings page with the detect_cluster panel;
 * custom agents made on the same behavior get the same page. Its old settings
 * table (twins_agent_config) is retired — DEP-037.
 */

import { TemplateAgentSettings } from '../../../components/agents/TemplateAgentSettings';
import { TWINS } from '../../../lib/ai/agentDefinitions';

export default function TwinsAgent() {
  return <TemplateAgentSettings def={TWINS} />;
}
